import React, { Component } from "react";
import * as d3 from "d3";

class barChart extends Component {
  constructor(props) {
    super();
    this.state = {
      chartData: props.chartData,
    };
  }

  bar = () => {
    const parentThis = this;
    var pwidth = document.getElementById("upper-left").clientWidth;
    var pheight = document.getElementById("upper-left").clientHeight;
    var margin = { top: 10, right: 30, bottom: 90, left: 40 },
      width = pwidth - margin.left - margin.right - 70,
      height = pheight - margin.top - margin.bottom - 18;
    // append the svg object to the body of the page
    var svg = d3
      .select("#my_dataviz")
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .style("margin-left", "30px")
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
    let data = this.state.chartData;
    // X axis
    var x = d3
      .scaleBand()
      .range([0, width])
      .domain(
        data.map(function (d) {
          return d.xData;
        })
      )
      .padding(0.2);
    svg
      .append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x))
      .selectAll("text")
      .attr("transform", "translate(-10,0)rotate(-45)")
      .style("text-anchor", "end");

    const xDatas = data.map(function (object) {
      return object.xData; // creating array of keys
    });
    const yDataArr = data.map(function (object) {
      return object.yData; // creating array of values
    });
    let maxValue = d3.max(yDataArr); // defining max value
    if (maxValue <= 0) {
      maxValue = 5;
    }

    // Add Y axis
    var y = d3.scaleLinear().domain([maxValue, 0]).range([0, height]);
    svg.append("g").call(d3.axisLeft(y));

    // Bars
    svg
      .selectAll("mybar")
      .data(data)
      .enter()
      .append("rect")
      .attr("x", function (d) {
        return x(d.xData);
      })
      .attr("width", x.bandwidth())
      .attr("fill", "#69b3a2")
      .attr("height", function (d) {
        return height - y(0);
      }) // always equal to 0
      .attr("y", function (d) {
        return y(0);
      })
      .on("mouseover", function (d) {
        if (parentThis.props.actionOnClick) {
          parentThis.props.actionOnClick(d.TotalVehicle);
        }
      })
      .on("mouseout", function () {
        if (parentThis.props.actionOnClick) {
          parentThis.props.actionOnClick("");
        }
      });
    //label
    svg
      .selectAll("mybar")
      .data(data)
      .enter()
      .append("text")
      .text(function (d) {
        return d.yData.toFixed(0);
      })
      .attr("x", function (d) {
        return x(d.xData) + (x.bandwidth() - 10) / 2 + 5;
      })
      .attr("y", function (d) {
        return y(d.yData) - 2;
      })
      .attr("font-family", "sans-serif")
      .attr("font-size", "10px")
      .attr("fill", "black")
      .attr("text-anchor", "middle")
      .style("display", "block");

    svg
      .select("text")
      .transition()
      .duration(800)
      .attr("y", function (d) {
        return y(d.yData);
      })
      .attr("height", function (d) {
        return height - y(d.yData);
      })
      .delay(function (d, i) {
        return i * 100;
      });

    svg
      .append("text")
      .attr("class", "y label")
      .attr("text-anchor", "end")
      .attr("y", -38)
      .attr("x", -60)
      .attr("dy", ".73em")
      .attr("transform", "rotate(-90)")
      .text(this.props.label)
      .style("margin-top", "20px")
      .style("font-size", "12px");

    // Animation
    svg
      .selectAll("rect")
      .transition()
      .duration(800)
      .attr("y", function (d) {
        return y(d.yData);
      })
      .attr("height", function (d) {
        return height - y(d.yData);
      })
      .delay(function (d, i) {
        return i * 100;
      });
  };
  componentDidMount() {
    this.bar();
  }
  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(this.props.chartData) !==
      JSON.stringify(prevProps.chartData)
    ) {
      this.setState(
        {
          chartData: this.props.chartData || [],
        },
        function () {
          if (this.state.chartData.length > 0) {
            d3.select("#my_dataviz").html("");
            this.bar();
          }
        }
      );
    }
  }
  render() {
    return (
      <div>
        <div id="my_dataviz"></div>
      </div>
    );
  }
}

export default barChart;
